import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useLiveTick } from "./live";

export const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND}/api` });

export const mediaUrl = (u) => (u && u.startsWith("/api") ? `${BACKEND}${u}` : u);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => String(x.msg).replace(/^Value error, /, "")).join(" · ");
  return d || e?.message || "Error";
};

export function useApi(path) {
  const [state, setState] = useState({ data: null, loading: true, error: null });
  const tick = useLiveTick();
  const last = useRef(null);
  useEffect(() => {
    if (!path) return undefined;
    let alive = true;
    const silent = last.current === path;
    last.current = path;
    if (!silent) setState((s) => ({ ...s, loading: true }));
    api.get(path)
      .then((r) => alive && setState({ data: r.data, loading: false, error: null }))
      .catch((e) => alive && (!silent || e?.response?.status === 404) && setState({ data: null, loading: false, error: e }));
    return () => { alive = false; };
  }, [path, tick]);
  return state;
}
